/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MinimalClientWithoutStatus = {
    id: number;
    firstName: string;
    lastName: string;
    gender: MinimalClientWithoutStatus.gender;
    email: string | null;
    phoneNumber: string | null;
    deleted: boolean;
};
export namespace MinimalClientWithoutStatus {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

